export const fontFamilyBaseTokens = {
  "font.family.heading": "Roboto",
  "font.family.base": "Inter"
} as const;

export type FontFamilyToken = keyof typeof fontFamilyBaseTokens;

export const getFontFamilyTokenValue = (token: FontFamilyToken): string => fontFamilyBaseTokens[token];

export const fontWeightBaseTokens = {
  "font.weight.regular": 400,
  "font.weight.medium": 500,
  "font.weight.semibold": 600
} as const;

export type FontWeightToken = keyof typeof fontWeightBaseTokens;

export const getFontWeightTokenValue = (token: FontWeightToken): number => fontWeightBaseTokens[token];

export const fontSizeBaseTokens = {
  "font.size.xxs": "11px",
  "font.size.xs": "12px",
  "font.size.sm": "13px",
  "font.size.md": "14px",
  "font.size.lg": "18px",
  "font.size.xl": "20px",
  "font.size.xxl": "24px"
} as const;

export type FontSizeToken = keyof typeof fontSizeBaseTokens;

export const getFontSizeTokenValue = (token: FontSizeToken): string => fontSizeBaseTokens[token];

export const fontLineHeightBaseTokens = {
  "font.line-height.tight": 1.2,
  "font.line-height.normal": 1.4
} as const;

export type FontLineHeightToken = keyof typeof fontLineHeightBaseTokens;

export const getFontLineHeightTokenValue = (token: FontLineHeightToken): number =>
  fontLineHeightBaseTokens[token];
